@if (isNew()) {
@if (newOptions().length != 0) {
<div class="row normal-row">
    <meta-select-button [availableMetas]="this.newOptions()" [alreadySelected]="this.alreadySelectedFN()"
        (onSelect)="onNew($event)" [labelCb]="this.labelFn()" />
</div>
}
} @else {
<div class="row normal-row clickable" [class.parent-bck]="!this.showFocus" [class.key-select]="this.showFocus" (click)="open()">
    <div>{{this.displayText()}}</div>
</div>
}
<kendo-dialog *ngIf="this.isEditing" title="Uren Tellers" width="400px" (close)="this.close()" autoFocusedElement="input">
    <div class="row">
        <kendo-label text="No" [style]="{'width':'100%'}">
            <kendo-dropdownlist [data]="this.tMenu()" [valuePrimitive]="true" [(value)]="this.editValue.no"
                [valueField]="'index'" [textField]="'label'"></kendo-dropdownlist>
        </kendo-label>
    </div>
    <div>
        <kanaal-input
            [initialValue]="{ ioType: ioType, range: 1 , start: this.editValue.kanaal, inverted: this.editValue.inverted}"
            (valueChanged)="onKanaalInputChanged($event)"></kanaal-input>

    </div>
    <kendo-dialog-actions>
        <button kendoButton (click)="this.close()">Cancel</button>
        <button kendoButton (click)="onDelete()" themeColor="primary" *ngIf="!isNew()">
            Delete
        </button>
        <button kendoButton (click)="onSave()" themeColor="primary">
            Save
        </button>
    </kendo-dialog-actions>

</kendo-dialog>